// Production config for GISMO deployment (liquido.dynv6.net).
// This file is gitignored; reconstructed on 2026-09-11 from the values embedded in the
// previously-deployed build's bundled JS (config values end up client-visible anyway,
// nothing here is secret) since no source copy existed on GISMO or in the repo.

import common from "./config.common.js"

export default Object.assign({}, common, {
	configSource: "production",

	// The API ROOT, relative: Caddy proxies /api/v2/* to the backend on BOTH hosts, so each app calls the API on its
	// own origin (no CORS, same-origin WebAuthn challenge cookie). An absolute LIQUIDO URL here broke Polly.
	LIQUIDO_API_URL: "/api/v2",

	// The two apps, for the links from one to the other
	liquidoAppUrl: "https://liquido.dynv6.net",
	pollyAppUrl: "https://polly.liquido.dynv6.net",

	mockBackend: false,

	googleClientId: "673421517010-lkmgt75rsmgua6aojhpp6crjg1opuhvo.apps.googleusercontent.com",

	inviteLinkPrefix: "https://liquido.dynv6.net/welcome?inviteCode=",

	devLogin: {
		teamName: "RobTeam",
		admin: {
			name: "RobertTest",
			email: "rob@rob.de",
			mobilephone: "+4955511111",
		},
		member: {
			name: "Membrrr",
			email: "membr@liquido.vote",
			mobilephone: "+4955522222",
		},
		token: "DEV_LOGIN_TOKEN_GISMO",
	},
})
